import { get, forEach, toNumber } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc CallTrendsDurationReports defines an HTTP service interface to send HTTP network requests.
 * @example
 * import { CallTrendsDurationReportsService } from 'services/callTrendsDurationReports';
 *
 * // create service instance and send/cancel request
 * const callTrendsDurationReportsService = new CallTrendsDurationReportsService();
 * const result = await callTrendsDurationReportsService.fetchData( '<user-id>' ); // fetch data
 * callTrendsDurationReportsService.cancel(); // cancel an active request
 */
export class CallTrendsDurationReportsService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const structure = get( response, 'body.component.structure', {} );
            const filterData = get( response, 'body.component.data.state', {} );
            const options = get( response, 'body.component.data.options', {} );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    structure,
                    visibility,
                    filterData: {
                        ...filterData,
                        options: options
                    },
                    options
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data  for graphs
    async fetchGraphData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const structure = get( response, 'body.component.structure', {} );
            const chartData = get( response, 'body.component.data.state', {} );
                
            // modify data for bar graphs
            const graphData = [];

            forEach( get( chartData, 'values', [] ), value => {

                graphData.push( {
                    name: value.name,
                    id: value.value,
                    value: toNumber( value.value ),
                } );
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    config: structure,
                    chartData: graphData,
                    totalCalls: chartData.totalCalls
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
